import { render, staticRenderFns } from "./LoadMoreDemo.vue?vue&type=template&id=56ce2813&scoped=true"
import script from "./LoadMoreDemo.vue?vue&type=script&lang=js"
export * from "./LoadMoreDemo.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreDemo.vue?vue&type=style&index=0&id=56ce2813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce2813",
  null
  
)

export default component.exports